import { defineMessages } from "react-intl";

const messages = defineMessages({
  duplicated: {
    id: "createActivityModal.cloningInfo",
    defaultMessage: 'Make any desired modifications and click "Create Activity" to duplicate.',
    description: "Information for duplicated activities",
  },
  header: {
    id: "createActivityModal.header",
    defaultMessage: "Create Activity",
    description: "Header of Create Activity modal",
  },
  logActivity: {
    id: "createActivityModal.footer.logActivity",
    defaultMessage: "Log Activity",
    description: "Log Activity button title on Create Activity modal",
  },
  requiredFields: {
    id: "createActivityModal.requiredFieldAlert",
    defaultMessage: "Fill out all required fields to log activity.",
    description: "Required Field alert while logging activity",
  },
  saveActivity: {
    id: "createActivityModal.footer.saveActivity",
    defaultMessage: "Save Activity",
    description: "Save Activity button title on Create Activity modal",
  },
  scheduleActivity: {
    id: "createActivityModal.footer.scheduleActivity",
    defaultMessage: "Schedule Activity",
    description: "Schedule Activity button title on Create Activity modal",
  },
  scheduleAnotherFollowUp: {
    id: "createActivityModal.footer.scheduleFollowUp.checkbox.another",
    defaultMessage: "Schedule another follow-up",
    description: "Schedule another follow-up label on Create Activity modal",
  },
  scheduleFollowUp: {
    id: "createActivityModal.footer.scheduleFollowUp.title",
    defaultMessage: "Schedule Follow-up",
    description: "Schedule follow-up ",
  },
  scheduleFollowUpNext: {
    id: "createActivityModal.footer.scheduleFollowUp.checkbox",
    defaultMessage: "Schedule follow-up on next step",
    description: "Schedule follow-up label on Create Activity modal",
  },
  tooltip: {
    id: "createActivityModal.footer.previewMode.tooltip",
    defaultMessage: "Please exit Preview Mode to log activity",
    description: "Create Activity modal - OK button tooltip in preview mode",
  },
});

export default messages;
